module.exports = __webpack_public_path__ + "static/media/icon_percent.6e18db55.svg";